import Grid from '@mui/material/Grid';

import {
  Entity,
  RELATION_API_PROVIDED_BY,
  RELATION_HAS_PART,
  RELATION_OWNED_BY,
  RELATION_OWNER_OF,
  RELATION_PART_OF,
} from '@backstage/catalog-model';
import { TableColumn } from '@backstage/core-components';
import {
  EntityTable,
  useEntity,
  useRelatedEntities,
} from '@backstage/plugin-catalog-react';

export const ApisCard = () => {
  const { entity } = useEntity();

  let parentRelationType: string;
  const columns: TableColumn<Entity>[] = [
    EntityTable.columns.createEntityRefColumn({}),
  ];

  if (entity.kind === 'System') {
    // Parent entity is Product
    parentRelationType = RELATION_HAS_PART;
    columns.push(
      EntityTable.columns.createEntityRelationColumn({
        title: 'Team',
        relation: RELATION_OWNED_BY,
        defaultKind: 'group',
      }),
    );
  } else {
    // Parent entity is Team
    parentRelationType = RELATION_OWNER_OF;
    columns.push(
      EntityTable.columns.createEntityRelationColumn({
        title: 'Provider',
        relation: RELATION_API_PROVIDED_BY,
        defaultKind: 'component',
      }),
      EntityTable.columns.createEntityRelationColumn({
        title: 'Product',
        relation: RELATION_PART_OF,
        defaultKind: 'system',
      }),
    );
  }

  const {
    entities = [],
    loading,
    error,
  } = useRelatedEntities(entity, {
    type: parentRelationType,
    kind: 'api',
  });

  if (loading || error) {
    return null;
  }

  return (
    <Grid item>
      <EntityTable title="APIs" columns={columns} entities={entities} />
    </Grid>
  );
};
